// extracted by mini-css-extract-plugin
module.exports = {"container":"List-module--container--2rtGC","item":"List-module--item--3iImA","card":"List-module--card---O2ps","icon":"List-module--icon--3N0NL","text":"List-module--text--1Vz1R"};